import { makeStyles } from '@material-ui/core/styles'
import { useState } from 'react'
import { Popover, Typography } from '@mui/material'
import { calculateAge } from 'src/utils/commonMethods/buyPolicy'
import {
  RELATION_TYPE_ENUMS,
  RELATION_TYPES,
} from 'src/utils/constants/BuyPolicy'
import { useSelector } from 'react-redux'
import { formatDateMonth } from 'src/utils/commonMethods/formatDate'
import { getFullName } from 'src/utils/commonMethods'

const ProposerDetailsReview = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const guestUserDetails = useSelector((state) => state?.buyPolicyReducer)
  const proposerDetails = guestUserDetails?.proposerDetails

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }
  const open = Boolean(anchorEl)

  const getSubHeading = (relation) => {
    return (
      <>
        <span className={classes.subHeadingRelation}>
          (&nbsp;{RELATION_TYPES?.[relation]}&nbsp;)
        </span>
      </>
    )
  }

  const getFullAddress = (address = {}) => {
    return `${address?.addressLine} ${address?.landmark} ${address?.city} ${address?.state} (${address?.pincode})`
  }

  return (
    <div className={classes.termsReview}>
      <span
        onClick={handleClick}
        className={classes.termsReviewContent}
        id='reviewFormButton'
      >
        <b>Review the Proposer Details.</b>
      </span>
      <Popover
        id='popover'
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        data-testid='close-button'
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Typography padding={2}>
          {/* {proposerDetails1.map((proposer, index) => ( */}
          <div>
            <div>
              <div className={classes.popoverContent}>
                <span className={classes.popoverHeading}>
                  <b>Proposer Details</b>
                </span>
              </div>
              <div className={classes.mainContainer}>
                <div className={classes.detailsContainer}>
                  <div>
                    <span className={classes.nameDetails}>
                      <b>
                        {getFullName([
                          proposerDetails?.firstName,
                          proposerDetails?.lastName,
                        ])}
                      </b>
                    </span>
                  </div>
                  <div>
                    <span className={classes.otherDetails}>
                      {proposerDetails?.gender}&nbsp;&nbsp;|&nbsp;&nbsp;
                    </span>
                    <span className={classes.otherDetails}>
                      {calculateAge(proposerDetails?.dateOfBirth)}{' '}
                      Yrs&nbsp;&nbsp;|&nbsp;&nbsp;
                    </span>
                    <span className={classes.otherDetails}>
                      {formatDateMonth(proposerDetails?.dateOfBirth)}
                    </span>
                  </div>
                </div>
                <div className={classes.OtherdetailsContainer}>
                  <div>
                    <span className={classes.otherSubDetails}>Email</span>
                    <br></br>
                    <span className={classes.otherDetails}>
                      {proposerDetails?.email}
                    </span>
                  </div>
                  <div>
                    <span className={classes.otherSubDetails}>Height</span>
                    <br></br>
                    <span className={classes.otherDetails}>
                      {proposerDetails?.height} CM
                    </span>
                  </div>
                  <div>
                    <span className={classes.otherSubDetails}>Weight</span>
                    <br></br>
                    <span className={classes.otherDetails}>
                      {proposerDetails?.weight} KG
                    </span>
                  </div>
                </div>
                <div>
                  <span className={classes.otherSubDetails}>Address</span>
                  <br></br>
                  <span className={classes.otherDetails}>
                    {getFullAddress(proposerDetails?.address?.currentAddress)}
                  </span>
                </div>
              </div>
            </div>
            <div>
              {guestUserDetails?.memberDetails
                ?.filter((item) => item?.relation !== RELATION_TYPE_ENUMS?.SELF)
                ?.map((familyMember) => (
                  <div key={'FamilyMmeber'} className={classes.mainContainer}>
                    <div className={classes.popoverContentFamily}>
                      <span className={classes.popoverHeading}>
                        <b>Family Details</b>
                      </span>
                    </div>
                    <div className={classes.detailsContainer}>
                      <div>
                        <span className={classes.nameDetails}>
                          <b>
                            {getFullName([
                              familyMember?.firstName,
                              familyMember?.lastName,
                            ])}
                            &nbsp;
                            {getSubHeading(familyMember?.relation)}
                          </b>
                        </span>
                      </div>
                      <div>
                        <span className={classes.otherDetails}>
                          {familyMember.gender}&nbsp;&nbsp;|&nbsp;&nbsp;
                        </span>
                        <span className={classes.otherDetails}>
                          {calculateAge(familyMember?.dateOfBirth)}{' '}
                          Yrs&nbsp;&nbsp;|&nbsp;&nbsp;
                        </span>
                        <span className={classes.otherDetails}>
                          {formatDateMonth(familyMember?.dateOfBirth)}
                        </span>
                      </div>
                    </div>
                    <div className={classes.heightWeightContainer}>
                      <div>
                        <span className={classes.otherSubDetails}>Height</span>
                        <br></br>
                        <span className={classes.otherDetails}>
                          {familyMember?.height} CM
                        </span>
                      </div>
                      <div>
                        <span className={classes.otherSubDetails}>Weight</span>
                        <br></br>
                        <span className={classes.otherDetails}>
                          {familyMember?.weight} KG
                        </span>
                      </div>
                    </div>
                    <hr className={classes.hr}></hr>
                  </div>
                ))}
            </div>
          </div>
        </Typography>
      </Popover>
    </div>
  )
}

export default ProposerDetailsReview

const useStyles = makeStyles({
  termsReview: {
    textAlign: 'center',
  },
  termsReviewContent: {
    fontFamily: 'Roboto !important',
    fontSize: '16px !important',
    color: '#2CA9CB !important',
    textDecoration: 'underline !important',
    textTransform: 'initial !important',
    cursor: 'pointer',
    fontStyle: 'italic',
  },
  popoverHeading: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    textTransform: 'uppercase',
    color: '#000000',
    width: '100%',
  },
  popoverContent: {
    textAlign: 'center',
    // opacity: '40%',
    boxShadow: '0px 0px 5px 0px #00000026',
    padding: '5px 0px 5px 0px',
    margin: '-15px -15px 20px -15px',
  },
  popoverContentFamily: {
    textAlign: 'center',
    // opacity: '40%',
    boxShadow: '0px 0px 5px 0px #00000026',
    padding: '5px 0px 5px 0px',
    margin: '20px -15px 20px -15px',
  },
  detailsContainer: {
    display: 'flex',
    marginBottom: '20px',
    gap: '30px',
  },
  OtherdetailsContainer: {
    display: 'flex',
    marginBottom: '20px',
    gap: '50px',
  },
  heightWeightContainer: {
    display: 'flex',
    marginBottom: '20px',
    gap: '50px',
  },
  mainContainer: {
    padding: '0px 0px 10px 0px',
  },
  nameDetails: {
    color: '#47BBDB',
    fontSize: '16px',
    fontFamily: 'Roboto',
    textTransform: 'capitalize',
  },
  otherDetails: {
    color: '#000000',
    fontSize: '13px',
    fontFamily: 'Roboto',
  },
  otherSubDetails: {
    color: '#959595',
    fontSize: '11px',
    fontFamily: 'Roboto',
  },
  hr: {
    borderStyle: 'dashed',
    color: '#959595',
  },
})
